// extracted by mini-css-extract-plugin
module.exports = {"Privacy":"PrivacyPolicy_Privacy__3qAWT","baseTitle":"PrivacyPolicy_baseTitle__3cXIG","subTitle":"PrivacyPolicy_subTitle__3ECea","ul":"PrivacyPolicy_ul__1ltMK"};